import { RewardsSource } from '../../graphql/camel'

export interface RewardsSourceConfig {
  filter: RewardsSource
  key: string
  name: string
  slug: string
}

export const rewardsSourceInPractice: RewardsSourceConfig = {
  key: 'inPractice',
  name: 'In Practice',
  slug: 'in-practice',
  filter: RewardsSource.InPractice,
}

export const rewardsSourceDispensary: RewardsSourceConfig = {
  key: 'dispensary',
  name: 'Dispensary',
  slug: 'dispensary',
  filter: RewardsSource.Dispensary,
}

export const rewardsSourceWebstore: RewardsSourceConfig = {
  key: 'webstore',
  name: 'Webstore',
  slug: 'webstore',
  filter: RewardsSource.DfhWebstore,
}

export const rewardsSourceWellWorld: RewardsSourceConfig = {
  key: 'wellWorld',
  name: 'Well World',
  slug: 'well-world',
  filter: RewardsSource.WellWorld,
}

export const rewardsSources: Array<RewardsSourceConfig> = [
  rewardsSourceInPractice,
  rewardsSourceDispensary,
  rewardsSourceWebstore,
  rewardsSourceWellWorld,
]
